"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useBasketProviderData = require("./useBasketProviderData");
Object.keys(_useBasketProviderData).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useBasketProviderData[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useBasketProviderData[key];
    }
  });
});
